import React, { useState } from 'react';
import { AddressContainer, Toast } from '@app/basketDetails/style';
import { Modal } from '@design-system/Modal/Modal';
import AddAddress from '../AddAddress';
import PropTypes from 'prop-types';
import Card from './card';
import { Text } from '@design-system/Text';
import { TextArea } from '@design-system/TextArea';
import { Button } from '@design-system/Button';
import commaNumber from 'comma-number';
import { toast } from 'react-hot-toast';

const Address = ({
  address,
  toggleSelected,
  selectedAddress,
  error,
  handleDeliveryNote,
  location,
  delivery_note,
  locations,
  deliveryFee,
}) => {
  const [show, setShow] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [note, setNote] = useState('');

  const open = () => {
    setShow(!show);
  };

  const close = () => {
    setShow(!show);
  };

  const handleSave = () => {
    handleDeliveryNote(note);
    setOpen(!isOpen);
    toast.success('Delivery Note Added!');
  };

  return (
    <div>
      <AddressContainer>
        <Toast show={!!error?.address}>
          <div className="content"> {error?.address}</div>
        </Toast>

        <Modal show={show} close={close}>
          <AddAddress locations={locations} selectedLocation={location} />
        </Modal>
        <Modal show={isOpen} close={() => setOpen(!isOpen)}>
          <Text size="large" fs="20px" align="center">
            Delivery Note
          </Text>
          <TextArea
            placeholder="Delivery Note"
            row="5"
            onChange={(e) => setNote(e.target.value)}
          />
          <Button
            onClick={handleSave}
            bgColor="#549A9A"
            weight="500"
            text="Save"
            width="100%"
          />
        </Modal>
        <div className="header">
          Address
          <div style={{ display: 'flex', gap: '10px', aligItems: 'center' }}>
            <h4 onClick={() => setOpen(!isOpen)}>Add Delivery Note</h4>
            <h4 onClick={() => open()}>Add Address</h4>
          </div>
        </div>

        <div className="body">
          {address.map((data) => (
            <Card
              data={data}
              key={data._id}
              onClick={() => toggleSelected(data)}
              selectedAddress={selectedAddress}
              locations={locations}
              selectedLocation={location}
            />
          ))}
        </div>

        <div className="delivery_region">
          <p>Delivery Region</p>
          <div className="locations">
            <div className="locations_card">
              <p>{location.location}</p>
              <h3>{`Timeline: ${location?.eta} ${
                location?.eta?.includes('days') || location?.eta?.includes('day')
                  ? null
                  : 'days'
              }`}</h3>

              <h3>
                price: {location?.price_bike?.currency?.symbol}
                {commaNumber(deliveryFee)}
              </h3>
            </div>

            {delivery_note && (
              <div className="locations_card">
                <p>Delivery Note</p>
                <h3>{delivery_note}</h3>
              </div>
            )}
          </div>
        </div>
      </AddressContainer>
    </div>
  );
};

export default Address;

Address.propTypes = {
  address: PropTypes.array.isRequired,
  toggleSelected: PropTypes.func,
  selectedAddress: PropTypes.object,
  error: PropTypes.object.isRequired,
  handleDeliveryNote: PropTypes.func.isRequired,
  location: PropTypes.object,
  delivery_note: PropTypes.string,
  locations: PropTypes.array,
  deliveryFee: PropTypes.number.isRequired,
};

Address.defaultProps = {
  toggleSelected: () => {},
  selectedAddress: {},
  location: {},
  delivery_note: '',
  locations: [],
};
